import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import _ from 'lodash'
import FuelStationsOwnDataForm from '../../../../components/fuel-stations/fuel-stations-own/FuelStationsOwnDataForm'
import useEditByLocation from '../../../../utils/hooks/useEditByLocation'
import useAccess from '../../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../../utils/constants/roles'
import useInputs from '../../../../utils/hooks/useInputs'
import { OwnFuelStationsService } from '../../../../services/own-fuel-stations/ownFuelStations.service'
import { validators } from '../../../../utils/helpers/validators'
import MainCommonView from '../../../../components/common/MainCommonView'

const OwnFuelStationData = () => {
  const { formatMessage: msg } = useIntl()
  const { id } = useParams()

  const { isEdit, enableEdit } = useEditByLocation()
  const { canEdit } = useAccess()
  const { inputs, onChangeInputs, updateInputs } = useInputs()

  useEffect(() => {
    getOwnFuelStationData()
  }, [])

  const getOwnFuelStationData = async () => {
    const resp = await OwnFuelStationsService.getById(id)
    if (resp) {
      updateInputs(resp?.resp)
    }
  }

  const handleUpdate = async () => {
    const data = {
      ..._.omit(inputs, 'comparisons'),
      center: inputs?.center?._id || inputs?.center,
      minetur: { ...inputs?.minetur, id: parseInt(inputs?.minetur?.id, 10) },
    }
    const response = await OwnFuelStationsService.update({
      id: inputs._id,
      body: data,
    })
    if (response) {
      updateInputs(response?.resp)
    }
  }

  const validateForm =
    validators.hasValue(inputs?.label) &&
    validators.hasValue(inputs?.minetur?.id) &&
    (validators.hasValue(inputs?.center) ||
      validators.hasValue(inputs?.center?._id)) &&
    validators.hasValue(inputs?.minetur?.user) &&
    validators.hasValue(inputs?.minetur?.key) &&
    validators.hasValue(inputs?.minetur?.cins) &&
    validators.hasValue(inputs?.monolith)

  const headerOptions = {
    title: msg({ id: 'data' }),
    handlerHeaderActions: {
      showBackButton: true,
      secondaryButton:
        isEdit && canEdit(MODULES.FUELSTATIONS, GROUPS.OWN) && handleUpdate,
      isDisabledSecondaryButton: !validateForm,
      secondaryButtonText: 'button.save',
      secondaryButtonIcon: 'pi-save',
      primaryButton:
        !isEdit && canEdit(MODULES.FUELSTATIONS, GROUPS.OWN) && enableEdit,
      primaryButtonText: 'button.enable.edit',
      primaryButtonIcon: 'pi-pencil',
    },
  }

  const data = (
    <div className="boxContainer">
      <FuelStationsOwnDataForm
        inputs={inputs}
        onHandleChange={onChangeInputs}
        isOnlyInfo={!isEdit}
      />
    </div>
  )

  return (
    <div className="own-data">
      <MainCommonView headerOptions={headerOptions} componentData={data} />
    </div>
  )
}

export default OwnFuelStationData
